import { useEffect, useRef } from 'react'
import { useAudioStore } from '@/store/AudioStore.ts'

export const useGlobalAudio = () => {
    const isPlaying = useAudioStore((state) => state.isPlaying)
    const isBlocked = useAudioStore((state) => state.isBlocked)
    const setBlocked = useAudioStore((state) => state.setBlocked)
    const audioRef = useRef<HTMLAudioElement | null>(null)

    useEffect(() => {
        if (isPlaying) {
            audioRef.current?.play().catch((error) => {
                if (error?.name === 'NotAllowedError') {
                    setBlocked(true)
                    return
                }
                console.error('Audio play failed:', error)
            })
        } else {
            audioRef.current?.pause()
        }
    }, [isPlaying])

    // 화면을 한 번 누르거나 키를 치면 브라우저가 재생을 허용한다. 그 입력에서 다시 튼다
    useEffect(() => {
        if (!isBlocked) return
        const retry = (e: Event) => {
            if (e instanceof KeyboardEvent && e.key === 'Escape') return
            if (!useAudioStore.getState().isPlaying) {
                setBlocked(false)
                return
            }
            audioRef.current?.play()
                .then(() => setBlocked(false))
                .catch(() => {})
        }
        const events = ['pointerdown', 'keydown', 'click']
        events.forEach((type) => window.addEventListener(type, retry, true))
        return () => events.forEach((type) => window.removeEventListener(type, retry, true))
    }, [isBlocked])

    return {
        audioRef,
        audioSrc: '/emergency-alert.mp3'
    }
}
